import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { CmsContentService } from './cms-content.service';

export const cmsContentResolver: ResolveFn<void> = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const cmsContentService = inject(CmsContentService);

  const context = route.params['context'];
  const id = route.params['id'];

  await Promise.all([cmsContentService.load(context, +id), cmsContentService.detailForRendering(context, +id)]);
};
